import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const scrollTo = (id: string) => {
    if (location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">
          <div>
            <Link to="/">
              <img src="/slatewing-logo.png" alt="Slatewing Technologies" className="footer-logo-img" />
            </Link>
            <div className="footer-copy" style={{ marginTop: 8 }}>
              © {year} Slatewing Technologies. All rights reserved.
            </div>
          </div>
          <div className="footer-links">
            <Link to="/services" className="footer-link">Services</Link>
            <Link to="/hire-developers" className="footer-link">Hire Developers</Link>
            <a href="/#about" className="footer-link" onClick={(e) => { e.preventDefault(); scrollTo('about'); }}>About</a>
            <Link to="/contact" className="footer-link">Get In Touch</Link>
            <a href="tel:+917359005500" className="footer-link">+91 73590 05500</a>
            <a href="mailto:team@slatewing.com" className="footer-link">team@slatewing.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
